import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BackendLoyaltyService } from '../../services/backend-loyalty.service';
import * as ParticipationAction from '../../actions/loyalty/actions-participation';
import { LoyaltyAlertService } from '../../services/LoyaltyAlertService';
import { select, Store } from '@ngrx/store';
import { Customer, customerConfig, HeaderAlertService, InitCustomerConfig } from '@uxdf/direct-shared-lib';
import * as CoreActions from '@uxdf/direct-shared-lib/src/lib/login/core.actions';
import { LoyaltyTileHelperService } from '../../services/loyalty-tile-helper.service';

@Injectable()
export class EffectsParticipation {
  approve$ = createEffect((): any => {
    return this.actions$.pipe(
      ofType(ParticipationAction.LOYALTY_APPROVE),
      withLatestFrom(this.store.pipe(select(customerConfig))),
      switchMap(([, /* action */ customerConfigState]: [ParticipationAction.ApprovingParticipation, any]) => {
        const config: Customer = customerConfigState.customerConfig;

        return this.backendLoyaltyService
          .approveForHierarchy(config.central_account_number, config.default_store_code)
          .pipe(
            map((data: boolean) => {
              return new ParticipationAction.ApprovingParticipationSuccess(data);
            }),
            catchError(error => {
              if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
                return of(new CoreActions.DirectUserRoleHasBeenChanged());
              } else {
                this.alert.add({
                  type: 'error',
                  content: $localize`:@@effects-participation.pageSomethingwentwrongHeading:Oops... Something went wrong`
                });
                return this.approve$;
              }
            })
          );
      }));
  });

  request$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ParticipationAction.LOYALTY_REQUEST),
      withLatestFrom(this.store.pipe(select(customerConfig))),
      switchMap(([, /* action */ customerConfigState]: [ParticipationAction.RequestParticipation, any]) => {
        const config: Customer = customerConfigState.customerConfig;

        return this.backendLoyaltyService
          .requestToHierarchy(config.central_account_number, config.default_store_code)
          .pipe(
            map((data: boolean) => {
              this.loyaltyAlertService.alertRequestLoyaltySuccess();
              return new ParticipationAction.RequestParticipationSuccess(data);
            }),
            catchError(error => {
              if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
                return of(new CoreActions.DirectUserRoleHasBeenChanged());
              } else {
                this.loyaltyAlertService.alertRequestLoyaltyError(error);
                return of(new ParticipationAction.RequestParticipationError(error));
              }
            })
          );
      })
    )
  });

  approveSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ParticipationAction.LOYALTY_APPROVE_SUCCESS),
      filter((action: ParticipationAction.ApprovingParticipationSuccess) => action.payload),
      switchMap(() => {
        this.loyaltyTileHelperService.alertApproveSuccess();
        return of(new InitCustomerConfig());
    })
  );
});

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly backendLoyaltyService: BackendLoyaltyService,
    private readonly loyaltyAlertService: LoyaltyAlertService,
    private readonly loyaltyTileHelperService: LoyaltyTileHelperService,
    private readonly store: Store<any>,
    private readonly alert: HeaderAlertService
  ) { }
}
